module.exports = __webpack_public_path__ + "img/d_cherniaev.a9a30ba5.jpg";